import { defaultTheme, legacyStyles, styles } from '@signavio/ui';
export const utils = {
  ...styles,
  ...legacyStyles
};
export const variables = {
  lineHeight: {
    clear: 1.5,
    block: 40,
    small: 26
  }
};
export const padding = defaultTheme.padding;
export const font = defaultTheme.font;
export const theme = defaultTheme;